import { forwardRef, type Ref, type SVGProps } from "react";
const IconDollarSignCircleFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2m.74 20.13v.38a1 1 0 0 1-2 0v-.43a3.92 3.92 0 0 1-3.35-2.27 1.4 1.4 0 0 1-.1-.49c0-.53.36-.85 1-.85a1 1 0 0 1 1 .65 3.45 3.45 0 0 0 3.26 1.49c1.39-.08 2.22-.74 2.22-1.76s-.6-1.44-2.21-1.83l-1.61-.36c-2.42-.54-3.55-1.59-3.55-3.32s1.31-3.05 3.39-3.4V9.5a1 1 0 0 1 2 0v.39c1.84.21 3.21 1.1 3.62 2.39a1.5 1.5 0 0 1 .08.49c0 .45-.35.74-.91.74a1.09 1.09 0 0 1-1-.64 3.2 3.2 0 0 0-3-1.47c-1.25.13-2.11.78-2.11 1.7s.64 1.43 2 1.79l1.65.36c2.57.58 3.67 1.57 3.67 3.32-.04 2.34-2.06 3.36-4.05 3.56" />
  </svg>
);
const ForwardRef = forwardRef(IconDollarSignCircleFilledSVG);
ForwardRef.displayName = "IconDollarSignCircleFilled";
export { ForwardRef as IconDollarSignCircleFilled };
